import "core-js/modules/web.dom.iterable";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import intersection from 'lodash/intersection';
import categoryQuery from '~/graphql/category.gql';
import categoriesQuery from '~/graphql/categories.gql';
import productsQuery from '~/graphql/products.gql';
import customizeProductQuery from '~/graphql/customizeProduct.gql';
import productPricesQuery from '~/graphql/product/prices.gql';
import TYPES from '~/const/editorial';
import { fetchDocumentsById } from '~/services/editorial';
const QUERIES = {
  productPrices: productPricesQuery,
  products: productsQuery,
  category: categoryQuery,
  categories: categoriesQuery,
  customized: customizeProductQuery
};

const componentList = () => {
  const paths = TYPES.filter(e => e.path);
  const slices = TYPES.filter(e => e.slices).map(e => e.slices).reduce((e, f) => e.concat(f), []);
  return [...paths, ...slices];
};

const typeDefinition = alias => {
  if (alias === 'null') {
    // When the alias is not defined in Prismic, it matches 'null' (/FR/fr/e/null/...)
    // In this case, we expect a 404
    return null;
  }

  return TYPES.find(e => e.aliases.includes(alias)) || TYPES.find(e => e.type === 'generic');
};

const sliceDefinition = (definition, slice) => definition.slices.find(e => e.name === slice.slice_type);

const supportedSlices = (definition, slices) => {
  const existing = definition.slices.map(e => e.name);
  const defined = slices.map(e => e.slice_type);
  return slices.filter(e => intersection(existing, defined).includes(e.slice_type));
};

const buildCatalogPayload =
/*#__PURE__*/
function () {
  var _ref2 = _asyncToGenerator(function* (_ref, slice, client, locale) {
    let {
      query,
      handler
    } = _ref;
    const {
      data
    } = yield client.query({
      query: QUERIES[query],
      variables: _objectSpread({
        locale
      }, handler(slice))
    });
    return data;
  });

  return function buildCatalogPayload(_x, _x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();

const buildEditorialArticle =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(function* (slice, store) {
    const {
      results
    } = yield fetchDocumentsById(store, [slice.primary.article.id]);
    return results;
  });

  return function buildEditorialArticle(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

const buildSlices = (definition, _ref4, client, store) => {
  let {
    body
  } = _ref4;
  const currentSlices = supportedSlices(definition, body);
  return Promise.all(currentSlices.map(
  /*#__PURE__*/
  function () {
    var _ref5 = _asyncToGenerator(function* (slice, position) {
      const {
        path,
        additional,
        article
      } = sliceDefinition(definition, slice);
      return {
        position,
        path,
        type: slice.slice_type,
        payload: {
          editorial: slice,
          catalog: additional ? yield buildCatalogPayload(additional, slice, client, store.state.i18n.currentLocale.iso) : null,
          article: article ? yield buildEditorialArticle(slice, store) : null
        }
      };
    });

    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }()));
};

export { componentList, typeDefinition, buildSlices };